import { NewsPost } from "../interfaces/interfaces";

export const newsPosts: NewsPost[] = [
  {
    id: 1,
    imageUrl: "/COUVERTURE ALBUM MADE IN AFRICA.webp",
    date: "2025-04-11",
    title:
      ' "MADE IN AFRICA" disponible en digital – Le nouvel album de Zied Zouari enfin à portée d’écoute !',
    description:
      "Zied Zouari signe son nouvel opus musical 'Made in Africa\"\", un album inédit aux sonorités africaines.\nPour la première fois au Maghreb, il associe un quatuor à cordes à un répertoire original célébrant l’africanité.\nComposé de titres exclusifs de Zied Zouari, ce projet fusionne Afro‑Jazz et modalité arabe, naviguant subtilement au coeur de la tradition orale et de l'improvisation.\nMade in Africa réinvente le chant bédouin telle une épopée blues moderne.",
    category: "Musique",
  },
  {
    id: 2,
    imageUrl: "/Birds B&W.webp",
    date: "2025-04-23",
    title: "Birds déploie ses ailes à l’Opéra de Lille",
    description:
      "Birds est un voyage onirique à travers le monde actuel, un questionnement sur l’identité plurielle que Zied Zouari porte à travers un parcours riche d’échanges et de rencontres. À vol d'oiseau, en prenant de la hauteur, on aperçoit bien mieux les choses, on attrape comme les vents la libre circulation des sons entre les différentes communautés noires du Maghreb, où l'esthétique des Gnawas du Maroc rencontre le Stambeli de Tunisie Projet musical et humaniste, Birds plane comme un voyage rêvé au-dessus du monde contemporain, sur les ailes du violoniste tunisien Zied Zouari, entouré de la contrebassiste Leïla Soldevila et de la violoncelliste Clémence Mebsout. Un trio de cordes qui fait vibrer la puissance du rythme soufi et la spiritualité du maqâm, et s'émancipe avec grâce des genres et des clichés, qu'ils soient culturels ou musicaux. Birds est une connivence incommensurable entre trois artistes fusionnels, passionnés de l’oralité et à l’univers sans limite.",
    category: "Concert ",
  },
  {
    id: 3,
    imageUrl: "/Capture d’écran 2025-04-05 203755.webp",
    date: "2025-04-25",
    title:
      'Made in Africa" : Une sortie d’album qui donne le coup d’envoi à Musica Tdour !',
    description:
      "Après le succès retentissant de\nCinéma Tdour, qui a su toucher les\nzones intérieures lointaines de la\ncapitale et des grandes villes,\nl'initiative a inspiré la création de\n“Mouzika Tdour”. Cette fois, le\ncamion se transforme en scène\nmobile de spectacle vivant et\nportera Musique et Image dans les\nzones les plus arriérées du pays.\nChaque arrêt devient une\nexpérience immersive où concerts\net projections se rencontrent,\ncréant un espace culturel vivant et\naccessible à tous.",
    category: "Concert",
  },
  {
    id: 4,
    imageUrl: "/Duplessy---violins.webp",
    date: "2025-05-06",
    title: "Duplessy & Violons du Monde",
    description:
      'Zied Zouari est l\'ambssadeur de région arabe dans le mythique groupe "Duplessy & The Violins of the World", un collectif de cinq violonistes du monde entier réunis par le grand compositeur et guitariste français Mathias Duplessy. Ils seront en tournée mondiale cette année à l\'occasion de la sortie de leur nouvel album "The Road with You" en France, Autriche, Lituanie, Allemagne Chine, USA, Russie. Ce projet sans équivoque réunit des musiciens de diverses traditions venues d’Inde, de Chine, de Mongolie, de Suède, de Cuba et de Tunisie.  ',
    category: "Concerts et Tournées",
  },
  {
    id: 5,
    imageUrl: "/59418126_1158288181022919_8642798758876151808_n.webp",
    date: "2019-07-02",
    title: "Road to Ramallah",
    description:
      "\"Road to Ramallah\" est une traversée musicale profonde signée Zied Zouari, un voyage entre douleur et espoir, entre mémoire et résistance. Porté par la chaleur du violon et des rythmes aux accents orientaux , ce morceau rend hommage à la Palestine, à sa terre et à son peuple. C’est une route symbolique, faite de silences, de cris contenus, et d’un souffle musical qui franchit les frontières pour affirmer une identité et une solidarité.",
    category: "Musique",
  },
  {
    id: 6,
    imageUrl: "/519957870_18392033287185342_38310652489898837_n.webp",
    date: "2025-07-24",
    title: "Ana chaabek",
    description:
      "Ana Chaabek est une opérette Tunisienne qui rassemble cent artistes de toute la Tunisie. Elle raconte la beauté des territoires, allant du Sud au Nord et fait intervenir un orchestre symphonique, une Chorale d'enfants ainsi que 13 Chanteurs et chanteuses de grande envergure. Cette opérette, sous la direction de Zied Zouari, est le fruit de partenariat entre la télévision nationale tunisienne, la radio nationale tunisienne et l’Opéra de Tunis",
    category: "Musique",
  }
];
